import React, { ComponentProps, useEffect } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobInvite } from '../../lib';
import { getLabel, setTitle } from "@weapp/utils";

function RouteMobInvite(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_x7eiky`} path={`${parentPath}/mobile/uk/invite/:type`}>
      {
        <MobInvite weId={`${props.weId || ''}_jx0jn0`} />
      }
    </Route>
  )
}

export default withRouter(RouteMobInvite);